import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import { toast } from "react-toastify";

const RenvoyerInvitationModal = ({ show, onHide, user }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (show && user) {
      setError(null);
      setInfo(null);
      setCopied(false);
    }
  }, [show, user]);

  const handleResend = async () => {
    if (!user) return;
    // Confirmation explicite: l'action réinitialise le mot de passe
    const confirmed = window.confirm(
      "Vous êtes sur le point de réinitialiser le mot de passe de cet utilisateur. Continuer ?"
    );
    if (!confirmed) return;

    setLoading(true);
    setError(null);

    try {
      const res = await axios.post(
        "/personnel/renvoyer-invitation/",
        {
          id_user: user.id_user,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (res.data?.success) {
        toast.success("🔁 Mot de passe réinitialisé. Nouveau code de connexion généré.");
        setInfo(res.data.data || null);
      } else {
        toast.warning("Action effectuée, mais sans confirmation claire");
      }
    } catch (err) {
      console.error("Erreur renvoi invitation:", err);
      if (err.response?.data?.detail) setError(err.response.data.detail);
      else setError("❌ Erreur lors de l'envoi de l'invitation");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!info) return;
    const block = `Identifiants de connexion\n\nLogin: ${info.login || ""}\nCode de connexion (mot de passe temporaire): ${info.mot_de_passe_temp || ""}\nCode de contrôle bulletin: ${info.code_controle || ""}\nLien: https://rh.aguipex.gov.gn/login`;
    try {
      await navigator.clipboard.writeText(block);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // fallback discret
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>📧 Renvoyer l'invitation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        {!info && (
          <Alert variant="warning">
            ⚠️ Cette action va <strong>réinitialiser le mot de passe</strong> de l'utilisateur et générer un
            <strong> code de connexion</strong>. Vous devrez transmettre ce code à l'utilisateur (aucun email automatique).
          </Alert>
        )}

        {info && (
          <Alert variant="success">
            <div className="mb-2"><strong>✅ Réinitialisation effectuée. Transmettez ces informations :</strong></div>
            <div><strong>Login :</strong> <code>{info.login}</code></div>
            <div><strong>Code de connexion (mot de passe temporaire) :</strong> <code>{info.mot_de_passe_temp}</code></div>
            <div><strong>Code de contrôle bulletin :</strong> <code>{info.code_controle || "—"}</code></div>
            <div><strong>Lien de connexion :</strong> <code>https://rh.aguipex.gov.gn/login</code></div>
            <div className="mt-3">
              <Button size="sm" variant={copied ? "success" : "outline-secondary"} onClick={handleCopy}>
                {copied ? "✅ Copié" : "📋 Copier"}
              </Button>
            </div>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!info ? (
          <>
            <Button variant="secondary" onClick={onHide}>
              Annuler
            </Button>
            <Button variant="primary" onClick={handleResend} disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Traitement...
                </>
              ) : (
                "Réinitialiser et générer le code"
              )}
            </Button>
          </>
        ) : (
          <Button variant="success" onClick={onHide}>
            Fermer
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default RenvoyerInvitationModal;
